import React from "react";
import { FeedStackSection } from "src/components/FeedContainer";
import { PremiseBox } from "src/components/Premises";

export const ContentSectionBelowLg = () => {
  return (
    <FeedStackSection
      renderContent={(row, index) => <PremiseBox key={index} row={row} />}
    />
  );
};
